import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequestHost } from "@tanstack/react-start/server";

import { portalOfHost, type Portal } from "./portal";

/**
 * Портал текущей страницы: на сервере — по заголовку Host, в браузере — по
 * адресу. Нужен маршрутам, чтобы выбрать оболочку и не показать подрядчику
 * экранов сотрудника. Права здесь не решаются — их решают серверные функции.
 */
export const currentPortal = createIsomorphicFn()
  .server((): Portal => portalOfHost(getRequestHost()))
  .client((): Portal => portalOfHost(window.location.hostname));

/** Страницы кабинета партнёра. Всё остальное — экраны сотрудника. */
export const PARTNER_PAGES = ["/cabinet"] as const;

/** Открыты без входа на портале партнёров. */
export function partnerPublicPath(path: string): boolean {
  return path === "/login" || path === "/privacy" || isInvitePath(path);
}

/** Приглашение: `/invite#…` и старые ссылки `/invite/<токен>`. */
export function isInvitePath(path: string): boolean {
  return path === "/invite" || path.startsWith("/invite/");
}

export function partnerPage(path: string): boolean {
  return PARTNER_PAGES.some((p) => path === p || path.startsWith(`${p}/`));
}
